import FancyBoxSvg281x200 from './FancyBoxSvg281x200';

export default FancyBoxSvg281x200;
export { FancyBoxSvg281x200 };
